import { service } from '../../../helpers/http'

export const ActionAlgorithmRunsIndex = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'indexRuns',
    payload,
  })
}

export const ActionAlgorithmRunsShow = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'showRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsEvents = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'eventsRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createTimetableRun',
    payload,
  })
}

export const ActionAlgorithmRunsTimetableGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listTimetableRunGroups',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createBasicEducationRun',
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationCopilot = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationDiagnostics = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'diagnosticsBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'groupsBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

// Disponibilidade do professor como o solver a viu no run (aba Grade).
export const ActionAlgorithmRunsBasicEducationTeacherAvailability = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'teacherAvailabilityBasicEducationRun',
    params: { id: payload.id, teacherId: payload.teacher_id },
  })
}

export const ActionAlgorithmRunsBasicEducationResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationSuggestions = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'suggestionsBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

// POST com id na rota: `params` resolve o {id} e `payload` vai no CORPO.
// Com `idAndPayload` o helper chama a action com UM argumento só, que o Vue
// Resource trata como query string — o corpo iria vazio e a validação falharia.
export const ActionAlgorithmRunsBasicEducationSimulate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'simulateBasicEducationRun',
    params: { id: payload.id },
    // `full`: reotimizar a escola inteira em vez do cenário local.
    payload: { suggestion_ids: payload.suggestion_ids, full: !!payload.full },
  })
}

// Medir o impacto de UMA sugestão. `deep` = medir a fundo (probe global).
export const ActionAlgorithmRunsBasicEducationMeasure = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'measureBasicEducationSuggestion',
    params: { id: payload.id, suggestionId: payload.suggestion_id },
    payload: { deep: !!payload.deep },
  })
}

// Medição automática em lote (probes locais de tudo que ainda não foi medido).
export const ActionAlgorithmRunsBasicEducationMeasureAll = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'measureAllBasicEducationSuggestions',
    params: { id: payload.id },
    payload: {},
  })
}

export const ActionAlgorithmRunsBasicEducationApplyScenario = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'applyScenarioBasicEducationRun',
    params: { id: payload.id },
    payload: { scenario_run_id: payload.scenario_run_id },
  })
}

export const ActionAlgorithmRunsTeacherAttributionCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createTeacherAttributionRun',
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionApply = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'applyTeacherAttributionRun',
    params: { id: payload.id },
    payload: payload.grid_ids ? { grid_ids: payload.grid_ids } : {},
  })
}

export const ActionAlgorithmRunsTeacherAttributionSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listTeacherAttributionRunGroups',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionItems = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'itemsTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionTeachersBoard = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'teachersBoardTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createAmbienceAllocationRun',
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationDashboard = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'dashboardAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listAmbienceAllocationRunGroups',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceBalanceCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createAmbienceBalanceRun',
    payload,
  })
}
